<template>
  <button
    class="button-toggle"
    :data-off="!isActiveFaceToFace"
    @click="toggleIsActiveFaceToFace"
  >
    <ToggleSwitch
      :modelValue="isActiveFaceToFace"
      @update:modelValue="toggleIsActiveFaceToFace"
    />
    {{ t('toggle_face_to_face') }}
  </button>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import {
  ij_isActiveFaceToFace,
  ij_toggleIsActiveFaceToFace,
} from '@/utils/injectionKeys.js';


const { t } = useI18n();

const isActiveFaceToFace = inject<Ref<boolean>>(ij_isActiveFaceToFace);
const toggleIsActiveFaceToFace = inject(
  ij_toggleIsActiveFaceToFace
) as () => void;
</script>

<style scoped lang="scss"></style>
